import {DetailsWrapperProps} from "./types";
import useOperationStaffController from "../../../../../controllers/operationStaff-controller";
import {Empty} from "antd";
import dayjs from "dayjs";
import {
  CalendarOutlined,
  ClockCircleOutlined,
  EnvironmentOutlined,
  MedicineBoxOutlined,
  TeamOutlined,
  UserOutlined
} from "@ant-design/icons";
import OperationStaffTags from "../staff-tags/OperationStaffTags";
import {getOperationStaffNames} from "../../../../../helpers/getOperationStaffNames";

const EMPTY_VALUE = "—";

const DetailsWrapper = ({data}: DetailsWrapperProps) => {
  const {operationStaffList} = useOperationStaffController();

  if (!data) {
    return <div className="surgery-details-empty"><Empty description="Дані операції відсутні"/></div>;
  }

  const operationDate = dayjs(data.operationTime);
  const isPast = operationDate.isBefore(dayjs());

  return <article className="surgery-details">
    <header className="surgery-details__hero">
      <div className="surgery-details__date-icon"><CalendarOutlined/></div>
      <div className="surgery-details__date">
        <span>Дата операції</span>
        <strong>{operationDate.format("DD.MM.YYYY")}</strong>
      </div>
      <div className="surgery-details__time">
        <ClockCircleOutlined/>
        <span><small>Час</small><strong>{operationDate.format("HH:mm")}</strong></span>
      </div>
      <span className={`surgery-details__status ${isPast ? "surgery-details__status--past" : ""}`}>
        {isPast ? "Завершено" : "Заплановано"}
      </span>
    </header>

    <div className="surgery-details__meta">
      <div>
        <span className="surgery-details__meta-icon"><EnvironmentOutlined/></span>
        <span><small>Операційна</small><strong>{data.operationRoom?.name || EMPTY_VALUE}</strong></span>
      </div>
      <div>
        <span className="surgery-details__meta-icon"><UserOutlined/></span>
        <span><small>Автор заявки</small><strong>{data.author || EMPTY_VALUE}</strong></span>
      </div>
    </div>

    <div className="surgery-details__columns">
      <section className="surgery-details-section">
        <header className="surgery-details-section__header">
          <span><TeamOutlined/></span>
          <div><small>Медичний персонал</small><h2>Операційна команда</h2></div>
        </header>
        <div className="surgery-details-list">
          <div><span>Хірург</span><OperationStaffTags names={getOperationStaffNames({staffList: operationStaffList, ids: data.surgeon})}/></div>
          <div><span>Асистенти</span><OperationStaffTags names={getOperationStaffNames({staffList: operationStaffList, ids: data.assistant})}/></div>
          <div><span>Анестезіолог</span><OperationStaffTags names={getOperationStaffNames({staffList: operationStaffList, ids: data.anesthesiologist})}/></div>
          <div><span>Сестра-анестезистка</span><OperationStaffTags names={getOperationStaffNames({staffList: operationStaffList, ids: data.anesthesiaNurse})}/></div>
          <div><span>Операційна сестра/брат</span><OperationStaffTags names={getOperationStaffNames({staffList: operationStaffList, ids: data.scrubNurse})}/></div>
        </div>
      </section>

      <section className="surgery-details-section">
        <header className="surgery-details-section__header">
          <span><MedicineBoxOutlined/></span>
          <div><small>Медичні дані</small><h2>Інформація про операцію</h2></div>
        </header>
        <dl className="surgery-details-data">
          <div><dt>Пацієнт</dt><dd>{data.patientName || EMPTY_VALUE}</dd></div>
          <div><dt>Група крові</dt><dd>{data.bloodType || EMPTY_VALUE}</dd></div>
          <div><dt>Діагноз</dt><dd>{data.diagnosis || EMPTY_VALUE}</dd></div>
          <div><dt>Операція</dt><dd>{data.operation || EMPTY_VALUE}</dd></div>
          <div><dt>Анестезія</dt><dd>{data.anesthesia || EMPTY_VALUE}</dd></div>
        </dl>
      </section>
    </div>
  </article>;
};

export default DetailsWrapper;
